import { createAction } from 'typesafe-actions';

import { EUndergroundTimeType } from 'shared/types/filters/advanced/undergroundTime';

export const changeUndergroundTimeTypeAction = createAction(
  'filters/undergroundTimeTypeChanged',
)<EUndergroundTimeType>();
